<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-13 00:16:23
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-12-02 12:00:46
-->
<template>
  <div class="detail-comment">
    <div v-for="(item, index) in list" :key="item.id" class="list-item">
      <div class="detail-top">
        <div class="avatar">
          <div class="avatar-img">
            <van-image
              @click="handlePersonal(item.userId)"
              round
              width="0.6rem"
              height="0.6rem"
              :src="item.userIconUrl"
            />
            <FansPendant v-if="item.userId" :userId="item.userId"/>
          </div>
          <span
            style="font-weight:500;"
            @click="handlePersonal(item.userId)"
          >
            &nbsp;{{item.userRealName}}
            <span v-if="author == item.userErp" class="author">作者</span>
          </span>
        </div>
        <span
          v-if="item.level === 1"
          class="comment-level"
        >
          {{item.floorNumber}} 楼
        </span>
      </div>
      <div class="item-content">
        <div :class="item.level > 1 ? 'small-font' : ''">
          <div v-if="item.content.indexOf('<img src') > -1 && item.delFlag > -1">
            <van-image
              v-for="(it, index) in imgSrcList(item.content)"
              :key="index"
              width="1.5rem" 
              height="1.5rem"
              :src="fomatSrc(it)"
              @click="handlePreviewImg(fomatSrc(it))"
              style="margin-right:10px"
            />
          </div>
          <span v-if="item.delFlag > -1">
            <span
              v-if="item.level > 1"
              class="comment-reply"
            >
              回复 {{item.BeReplyUserRealName}}：
            </span>
            <div class="comment-content">
            <div class="comment-html" v-html="getContent(item.content)" @click="clickContent">
            </div>
            <img
              v-if="item.orderType === 99"
                class='authority-flag'
                src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-06-27-16-56nT7BVwD56qZevpQl.png"
              />
              </div>
          </span>
          <span v-else class="detail-comment-desc">****此评论已删除****</span>
        </div>
        <div class="item-time">
          <span>{{item.createTime}}</span>
          <div v-if="item.delFlag > -1" style="display:flex;">
            <div
              v-if="item.level === 1"
              @click="shareComment(item)"
              class="operate-item">
              <van-icon name="share-o" size="14"/>
            </div>
            <div
              v-if="item.userErp === userInfo.erp"
              @click="handleDelete(item)"
              class="operate-item">
              <van-icon name="delete-o" size="14" />
            </div>
            <div
              @click="handleChat(item)"
              class="operate-item">
              <!-- <van-icon name="chat-o" size="14" /> -->
              <img style="width: 12px;height: 10px" src="../../../assets/huifu.png"/>
              <span>{{item.replyNum}}</span>
            </div>
            <div
              @click="handleUp(item)" 
              class="operate-item" :class="item.upOrDown > 0 ? 'up' : 'unUp'" >
              <van-icon name="good-job-o" size="14"/>
              <span>{{item.upNum}}</span>
            </div>
          </div>
        </div>
      </div>
      <van-divider v-if="item.level === 1 && !item.childrenList.totalCount && index < list.length - 1" class="item-content" />
      <DetailComment
        v-if="item.childrenList.totalCount"
        :list="item.childrenList.result"
        :total="item.childrenList.totalCount"
        :parentId="item.id"
        :curPage="item.currentPage"
        :author="author"
        :id="id"
        :last="index === list.length - 1"
        @refresh="handleRefresh"
        @comment="(_item) => handleChat(_item)"
        @updateList="handleUpdate"
        @refreshComment="handleRefreshComment"
        style="margin-left:26px;font-size:12px;" />
    </div>
    <div
      v-if="(list.length < total) && showMore"
      @click="handleLookMore()"
      class="more">
      查看全部{{total}}条回复
    </div>
    <van-divider v-if="!first && !last" />
  </div>
</template>

<script>
import api from '../../../api'
import { mapActions, mapState } from 'vuex'
import { ImagePreview } from 'vant';
import FansPendant from '../../../components/fansPendant.vue';

export default {
  name: 'DetailComment',
  components: {
    FansPendant,
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    parentId: {
      type: Number,
      default: 0
    },
    curPage: {
      type: Number,
      default: 1
    },
    author: {
      type: String
    },
    first: {
      type: Boolean,
      default: false
    },
    last: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: 0
    },
    showMore: {
      type: Boolean,
      default: true
    }
    
  },
  data() {
    return {
      showPop: false,
      message: '',
      btnLoading: false
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    ...mapActions(['updateUserInfoList']),
    handlePersonal(id) {
      if (id === -1) return;
      this.$router.push({ name: 'personal', query: { id } })
    },
    shareComment(item) {
      this.$emit('shareComment', item);
    },
    handleDelete(item) {
      this.$dialog.confirm({
        message: '评论删除后不可恢复',
      }).then(() => {
        api.deleteReplay(item.id).then(res => {
          if (res.code === 200) {
            this.$emit('refreshComment')
            this.$toast.success('删除成功')
          }
        })
      })
    },
    handleChat(item) { 
      const params = {
        postId: +this.id,
        replyId: item.replyId || item.id,
        type: 0
      }
      this.$emit('comment', params)
    },
    handleUp(item) {
      const params = {
        replyId: item.id,
        upOrDown: 1
      }
      this.$emit('refresh', item.id)
      api.upAndDown(params)
      return false
    },
    handleLookMore() {
      const params = {
        page: 1,
        pageSize: this.total,
        replyId: this.parentId
      }
      api.childReplyList(params).then(res => {
        const { code, data } = res
        if (code === 200) {
          this.$emit('updateList', this.parentId, data)
          const userIds = data?.map((item) => item.userId);
          if (userIds?.length) {
            this.updateUserInfoList(userIds.join())
          }
        }
      })
    },
    handleUpdate(id, childList) {
      this.$emit('updateList', id, childList, true)
    },
    handleRefresh(val) {
      this.$emit('refresh', val)
    },
    handleRefreshComment() {
      this.$emit('refreshComment')
    },
    imgSrcList(context) {
      /* eslint-disable */
      let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/gi
      return context.match(srcReg)
    },
    getContent(contentText) {
      const newContent = contentText?.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, '');
      return newContent;
    },
    fomatSrc(src) {
      return src.slice(5, -1);
    },
    handlePreviewImg(src) {
      ImagePreview([src]);
    },
    clickContent(e) {
      if (e.target.localName === 'a') {
        e.preventDefault();
        const url = e.target.href;
        if (url.startsWith('http://xingyun.jd.com/shendeng' || url.startsWith('http://jagile.jd.com/shendeng'))) {
          if (url.startsWith('http://xingyun.jd.com/shendeng/article/detail/') || url.startsWith('http://jagile.jd.com/shendeng/article/detail/')) {
            const pathnameAry = url.match(/\d+/g)
            this.$router.push({ name: 'articleDetail', params: { id: pathnameAry[0] } })
            return ;
          }
          if (url.startsWith('http://xingyun.jd.com/shendeng/bbs/detail/') || url.startsWith('http://jagile.jd.com/shendeng/bbs/detail/')) {
            const pathnameAry = url.match(/\d+/g)
            this.$router.push({ name: 'bbsDetail', params: { id: pathnameAry[0] } })
          }
        } else {
          window.jme.browser.openUrl({
              url
          });
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.avatar {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.list-item {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
}
.item-content {
  margin-left: 25px;
  word-break: break-word;
}
.item-time {
  color: #606266;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.operate-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  &:last-child {
    margin-right: 0;
  }
  > span {
    font-size: 12px;
    margin-left: 5px;
  }
}
.up {
  color: #2695F1;
  font-weight: 500;
}
.unUp {
  color: #606266;
  font-weight: 400;
}
.detail-comment /deep/ .van-popup {
  display: flex;
  flex-direction: column;
}
.detail-comment /deep/ .van-overlay {
  background-color: rgba(0,0,0,.2);
}
.detail-comment /deep/ .van-image__img {
  object-fit: contain;
}
.more {
  display: flex;
  // justify-content: center;
  margin-top: 0.2rem;
  padding-left: 25px;
  font-size: 12px;
  color: #2695F1;
}
.small-font {
  font-size: 13px;
}
.author {
  display: inline-block;
  color: #2695F1;
  font-size: 10px;
  border: 1px solid #2695F1;
  padding: 2px;
  border-radius: 4px;
  transform: scale(0.7);
}
.detail-comment-desc {
  font-style: italic;
  color: #606266;
}
.detail-top {
  display: flex;
  justify-content: space-between;
}
.comment-reply {
  color: #838383;
  font-size: 13px;
}
.comment-level {
  font-size: 12px;
  color: #838383;
  padding: 2px 6px;
  // border: 1px dashed #bbb;
}
.avatar-img {
  position: relative;
}
.comment-content {
  position: relative;
  .authority-flag {
    position: absolute;
    right: 0;
    top: -28px;
    height: 28px;
  }
}
.comment-html {
  /deep/ span[data-w-e-type="mention"] {
    margin-left: 3px;
    margin-right: 3px;
    background-color: #f5f2f0;
    border: 2px solid transparent;
    border-radius: 3px; padding: 0px 3px;
  }
}

</style>
